import axiosInstance from "./axiosInstance";

export const checkAuth = async () => {
  try {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    if (!userData.access_token) {
      return { authenticated: false };
    }
    
    const response = await axiosInstance.get("/auth/me");
    return { authenticated: true, user: response.data };
  } catch (error) {
    localStorage.removeItem("userData");
    return { authenticated: false };
  }
};

export const loginWithEmail = async (email) => {
  const response = await axiosInstance.post("/auth/login/email", { email });
  return response.data;
};

export const verifyOTP = async (email, otp) => {
  const response = await axiosInstance.post("/auth/login/verify-otp", {
    email,
    otp,
  });
  
  if (response.data.access_token) {
    localStorage.setItem("userData", JSON.stringify({
      access_token: response.data.access_token,
      refresh_token: response.data.refresh_token,
      user: response.data.user,
      organization: response.data.organization,
    }));
  }
  
  return response.data;
};

export const logout = () => {
  localStorage.removeItem("userData");
  window.location.href = "/login";
};

